import { mq, spacing, styled, Text } from '@thg-commerce/gravity-theme'
import { Separator, Skeleton } from '@thg-commerce/gravity-elements'
import { TextStyling } from '@thg-commerce/gravity-patterns'

const maxWidth = '560px'

export const StyledSeparator = styled(Separator)`
  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    max-width: ${maxWidth};
  }
`

export const ProductRatingWrapper = styled.div`
  margin: ${spacing(4)} 0 0;

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    max-width: ${maxWidth};
  }
`

export const ReviewSortByWrapper = styled.div`
  margin-top: ${spacing(3)};

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    p {
      max-width: ${maxWidth};
    }
  }
`

export const DisplayMobileOnlyContainer = styled.div`
  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    display: none;
  }
`

export const StyledReviewTitle = styled.h1<{
  textStyle?: TextStyling
}>`
  ${(props) =>
    Text(
      props.textStyle?.entry || 'large2',
      props.textStyle?.style || 'alternate',
    )}

  padding: ${spacing(2)} 0 ${spacing(3)};

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    display: none;
  }
`

export const PriceContainer = styled.div`
  margin: ${spacing(2)} 0 ${spacing(2)};
`

export const PriceSkeleton = styled(Skeleton)`
  width: 120px;
  height: 40px;
  margin: ${spacing(2)} 0;
`
